import betslip, {
    Betslip as Types,
    BetslipDefault,
} from '@gin-betting/betslip';

import UserDevice from 'services/user-device';
import handleBetslipModuleLoad from './async/handleBetslipModuleLoad';
import * as components from './components';
import * as constants from './constants';
import * as epics from './epics';

const {
    epics: { refetchStake, selectBetslipBetId, ...pickedEpics },
} = betslip;

export type { Types as Betslip, BetslipDefault };

const betslipModule = {
    ...betslip,
    constants: { ...betslip.constants, ...constants },
    epics: {
        ...pickedEpics,
        ...epics,
        ...(!UserDevice.getInstance()?.isDeviceMobile() && {
            selectBetslipBetId,
        }),
    },
    components,
};

export type BetslipModule = typeof betslipModule;

export default handleBetslipModuleLoad(betslipModule);
